import { CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { Mensaje } from 'app/mensaje';
import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';


@Component({
  selector: 'app-otros-pagos-lista',
  templateUrl: './lista.component.html'
})

export class OtrosPagosListaComponent{
  persona = null;
  alumno = null;
  configuracion;
  mensajeResponse: Mensaje = new Mensaje(true);
  public options = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  };

  constructor( private notificacion: NotificationsService, private http: HttpClient,   ){
   
  }
  ngOnInit(): void {
    this.configuracion = JSON.parse(localStorage.getItem("configuracion"));

    
  }


  mensaje(cuentaAtras: number = 6, posicion: any[] = ["bottom", "left"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };
    if (this.mensajeResponse.clase == 'alert')
      this.notificacion.alert(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'success')
      this.notificacion.success(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'info')
      this.notificacion.info(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'warning' || this.mensajeResponse.clase == 'warn')
      this.notificacion.warn(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'error' || this.mensajeResponse.clase == 'danger')
      this.notificacion.error(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

  }

  imprimir(item,i){
    let empresa = this.configuracion.empresa.nombre
    let sucursal = this.configuracion.sucursal.nombre
    let sucursal_direccion = this.configuracion.sucursal.direccion
    let rfc = this.configuracion.sucursal.facturacion.rfc
    let general = {}
    let articulos = []
    
  
    for (let index = 0; index < item.movimientos_articulos.length; index++) {
      const element = item.movimientos_articulos[index];
    
      articulos.push({
        'concepto':element.articulos.nombre,
        'cantidad': element.cantidad,
        'importe':this.convertirMoneda(element.precio_unitario),
        'descuento':this.convertirMoneda(element.descuento),
        'importe_descuento':this.convertirMoneda(element.precio_con_descuentos)
      })
      
    }

    general = {
     
      'body_email': {
        'configuracion': {
          'empresa': empresa,
          'sucursal': sucursal,
          'direccion': sucursal_direccion,
          'rfc': rfc
        },
        'codigo':item.codigo,
        'fecha':item.created_at,
        'persona':item.personas.nombre_completo,
        'correo': this.alumno.email,
        'movimientos':articulos,
        'subtotal':this.convertirMoneda(item.subtotal),
        'descuentos':this.convertirMoneda(item.descuento),
        'total': this.convertirMoneda(item.total),
        'forma_pago':item.pagos[0].tipos_formas_pagos.nombre.toUpperCase() + ": " + this.convertirMoneda(item.pagos[0].paga_con), 
        'cambio': this.convertirMoneda(item.pagos[0].cambio),
        'tipo_pago':item.pagos[0].tipos_metodos_pagos.nombre.toUpperCase()
      }
    }

  

    this.http.post('https://cum.api.managerescolar.app/api/v1/ticket-email',general).subscribe(res =>{
   
    this.mensajeResponse.titulo = 'Envio de Correo';
    this.mensajeResponse.texto = 'Correo enviado correctamente';
    this.mensajeResponse.mostrar = true;
    this.mensajeResponse.clase = 'success';
    this.mensaje(3);
      // console.log(res);
      
      
    },(e)=>{
      console.log(e);
  
      this.mensajeResponse.titulo = 'Envio de Correo';
      this.mensajeResponse.texto = 'El envio del correo fallo';
      this.mensajeResponse.mostrar = true;
      this.mensajeResponse.clase = 'error';
      this.mensaje(3);
    })
    
  }
  
  calcular_importe_articulo(item, json) {
    // sumamos las cantidades
    let total = 0; let c = 0; let restante = 0; let descuento = 0;

    json.movimientos_articulos.forEach(element => {
      let importe_desc = element.cantidad * element.precio_unitario;
      element.importe = element.cantidad * element.precio_unitario;
      if (element.descuento > 0) {
        let desc = element.descuento / 100;
        element.precio_con_descuentos = importe_desc - (importe_desc * desc);
        descuento += importe_desc * desc;
      }

      total = total + (element.cantidad * element.precio_unitario);

      json.importe = (element.importe);
      json.precio_con_descuentos = (element.precio_con_descuentos);
      c++;
    });

    let importe = 0;
    let cambio = 0;
    let i = 0;
    json.pagos.forEach(element => {
      importe = importe + element.paga_con;
    });

    json.subtotal = total;
    json.descuento = descuento;
    json.total = total - descuento;
    json.total_recibido = importe;
    json.cambio = importe - (total - descuento);

    document.getElementById("imprimirTicket").click();
  }

 
  asignarPersona(persona, dato,alumno){
    this.persona = persona;
    this.alumno = alumno;
    dato = [];
    document.getElementById("cargarLista").click();
  }

  convertirMoneda(importe) {
    return (new CurrencyPipe('en')).transform(importe, this.configuracion.sucursal.moneda, true);
  }
}
